import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  Input,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../App/Helpers/callApi";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import { addEventVenue, getEventVenues } from "../EventVenuesService";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  copy: {
    color: theme.palette.primary.copy,
  },
}));
export default function AddEventVenueModal({
  openModal,
  client,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [name, setName] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country, setCountry] = useState("");

  function addSponsor() {
    if (!checkAllEntered()) {
      setInputError(true);
      return;
    }
    let json = {
      ClientId: client.id,
      Name: name,
      Address: address,
      City: city,
      Division: state,
      Zipcode: zipcode,
      Country: country,
      Website: website,
      PhoneNumber: phone,
      EmailAddress: email,
    };

    callAPI(
      addEventVenue(json),
      "Venue Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventVenues(client.id).then((response) => {
        setTableData(response);
        openModal(false);
      });
    });
  }

  const checkAllEntered = () => {
    if (
      name === "" ||
      address === "" ||
      city === "" ||
      state === "" ||
      zipcode === "" ||
      country === ""
    ) {
      return false;
    }
    return true;
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Event Venue
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Name"
                  label="Name"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && name === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {inputError && name === "" && (
                  <FormHelperText className={classes.error}>
                    Name Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Website"
                  label="Website"
                  variant="standard"
                  fullWidth
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Email Address"
                  label="Email Address"
                  variant="standard"
                  fullWidth
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Phone Number"
                  label="Phone Number"
                  variant="standard"
                  fullWidth
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  placeholder="Address"
                  label="Address"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && address === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                {inputError && address === "" && (
                  <FormHelperText className={classes.error}>
                    Address Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="City"
                  label="City"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && city === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
                {inputError && city === "" && (
                  <FormHelperText className={classes.error}>
                    City Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="State/Division"
                  label="State/Division"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && state === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                />
                {inputError && state === "" && (
                  <FormHelperText className={classes.error}>
                    State/Division Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Zip Code"
                  label="Zip Code"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && zipcode === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={zipcode}
                  onChange={(e) => setZipcode(e.target.value)}
                />
                {inputError && zipcode === "" && (
                  <FormHelperText className={classes.error}>
                    Zip Code Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Country"
                  label="Country"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && country === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                />
                {inputError && country === "" && (
                  <FormHelperText className={classes.error}>
                    Country Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addSponsor()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
